import React from "react";
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";
import Grid from "@material-ui/core/Grid/Grid";

export const ListSkeleton = (props) => (
    <React.Fragment>
        <Grid container spacing={1} justifyContent={"center"}>
            <Grid item xs={5}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>
            <Grid item xs={12}>
                <Skeleton style ={props.style}   variant="rect" height={40} />
            </Grid>

        </Grid>
    </React.Fragment>

)